import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useState } from 'react';

var useLikes = function useLikes() {
  // put all values of likes as state
  var _useState = useState({}),
      allLikes = _useState[0],
      setAllLikes = _useState[1]; // set an initial value of likes


  var setInitialLikesHandler = function setInitialLikesHandler(initialData) {
    setAllLikes(initialData);
  }; // update a value of likes


  var setLikesHandler = function setLikesHandler(id, likes) {
    setAllLikes(function (prevState) {
      var _Object$assign;

      return Object.assign({}, prevState, (_Object$assign = {}, _Object$assign[id] = likes, _Object$assign));
    });
  }; // if there is id in local storage


  var _useState2 = useState({}),
      hasLikes = _useState2[0],
      setHasLikes = _useState2[1]; // check if there is id in local storage & set state accordingly


  var checkLikesHandler = function checkLikesHandler(id) {
    var data = localStorage.getItem(id);
    setHasLikes(function (prevState) {
      var _Object$assign2;

      return Object.assign({}, prevState, (_Object$assign2 = {}, _Object$assign2[id] = data === 'yes' ? true : false, _Object$assign2));
    });
  }; // set updated hasLikes


  var setHasLikesHandler = function setHasLikesHandler(id, updated) {
    setHasLikes(function (prevState) {
      var _Object$assign3;

      return Object.assign({}, prevState, (_Object$assign3 = {}, _Object$assign3[id] = updated, _Object$assign3));
    });
  }; // triggered when user click heart icon
  // update(inc or dec) value of likes


  var updateLikesHandler = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id, mode) {
      var _yield$fetch$then, _id, likes;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch('/.netlify/functions/update-likes', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json'
                },
                body: JSON.stringify({
                  id: id,
                  mode: mode
                })
              }).then(function (res) {
                return res.json();
              });

            case 3:
              _yield$fetch$then = _context.sent;
              _id = _yield$fetch$then._id;
              likes = _yield$fetch$then.likes;

              // if user likes the article
              if (mode === 'inc') {
                localStorage.setItem(id, 'yes');
                setHasLikesHandler(id, true); // if user dislike the article
              } else {
                localStorage.removeItem(id);
                setHasLikesHandler(id, false);
              }

              setLikesHandler(_id, likes);
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              console.log({
                err: _context.t0
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    }));

    return function updateLikesHandler(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    allLikes: allLikes,
    hasLikes: hasLikes,
    setInitialLikesHandler: setInitialLikesHandler,
    setLikesHandler: setLikesHandler,
    checkLikesHandler: checkLikesHandler,
    updateLikesHandler: updateLikesHandler
  };
};

export default useLikes;